import { Expose } from 'class-transformer';
import { CardPointsToExpireApiModel } from './card-points-to-expire.api.model';

export class CardApiModel {
  @Expose()
  id: string;

  @Expose()
  cardTypeId: string;

  @Expose()
  name: string;

  @Expose()
  description: string;

  @Expose()
  message: string;

  @Expose()
  picture: string;

  @Expose()
  number: string;

  @Expose()
  flgSubscription: boolean;

  @Expose()
  type: number;

  @Expose()
  valueBalance: number;

  @Expose()
  pointsBalance: number;

  @Expose()
  expiryDate: string;

  @Expose()
  typeDescriptions: string[];

  @Expose()
  pointsToExpire: CardPointsToExpireApiModel[];

  @Expose()
  collectedPoints: number;

  @Expose()
  batchName: string;
}
